// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logoNewHomePage {\n  width: 160px;\n  height: 60px;\n}\n@media (max-width: 500px) {\n  .logoNewHomePage {\n    width: 85px;\n    height: 32px;\n  }\n}", ""]);
// Exports
module.exports = exports;
